(function ($, window, Drupal) {
  'use strict';

  /**
   * Toggles media-query specific body classes.
   *
   * You can define new media queries to listen to by writing them into the
   * Drupal.settings.omegaSettings.mediaQueries array.
   */
  Drupal.behaviors.omegaMediaQueryClasses = {
    handler: function (name, mql) {
      if (mql.matches) {
        $('body').removeClass(name + '-inactive').addClass(name + '-active');
      }
      else {
        $('body').removeClass(name + '-active').addClass(name + '-inactive');
      }
    },
    attach: function (context, settings) {
      var behavior = this;

      $(context).find('body').once('omega-mediaqueries').each(function () {
        var mediaQueries = {
          'mobile': 'all and (max-width: 767px)',
          'tablet': 'all and (min-width: 767px)',
          'desktop': 'all and (min-width: 900px)'
        };

        $.each(mediaQueries, function (index, value) {
          var mql = window.matchMedia(value);

          // Initially, check if the media query applies or not and add the
          // corresponding class to the body.
          behavior.handler(index, mql);

          // React to media query changes and toggle the class names.
          mql.addListener(function (mql) {
            behavior.handler(index, mql);
          });
        });
      });
    }
  };

  Drupal.behaviors.OysterThemeScrollDown = {
    attach: function (context, settings) {
      jQuery('#block-homepagebanner .more').click(function () {
        jQuery('html, body').animate({
          scrollTop: jQuery('#node-1').offset().top - 100
        }, 1500);
        return false;
      });
      // Hide header contact on mobile if scrolled to bottom of the page.
      $(document).scroll(function() {
        if ($(window).width() <= 600) {
          if($('#site-footer').isInViewport()){
            $('.header_contact').hide();
          }
          else {
            $('.header_contact').show();
          }
        }
      });
    }
  };

  Drupal.behaviors.OysterThemeFlexslider = {
    attach: function (context, settings) {
      if ($.isFunction($.fn.flexslider)) {
        $('.oyster-homepage-banner').flexslider({
          fadeFirstSlide: false
        });
      }
    }
  };

  Drupal.behaviors.OysterThemeSwipebox = {
    attach: function (context, settings) {
      if ($.isFunction($.fn.swipebox)) {
        $('.swipebox').swipebox();
      }
    }
  };

  Drupal.behaviors.OysterThemeSelect2 = {
    attach: function (context, settings) {

      if ($.isFunction($.fn.select2)) {
        $('select').select2({
          minimumResultsForSearch: -1
        });

        var $archiveSelect = $('.case-study-filter .js-form-item-industry');
        $archiveSelect.on('select2:select', function (e) {
          $('.case-study-filter .js-form-submit').click();
        });

        var $newsSelect = $('.news-filter .js-form-item');
        $newsSelect.on('select2:select', function (e) {
          $('.news-filter .js-form-submit').click();
        });

        var $newsSelect = $('.resource-listing-filter .js-form-item');
        $newsSelect.on('select2:select', function (e) {
          $('.resource-listing-filter .js-form-submit').click();
        });

        // Add classes to languages selector.
        $($('#edit-languages-select').data('select2').$container).addClass("languages-select")
        $($('#edit-languages-select').data('select2').$container).click(() => $.each($("span.select2-container"), (index, value) => {
          if (index === $("span.select2-container").length - 1) {
            $(value).addClass("languages-select")
          }
        }));
        $(".languages-select").click(function() {
          // Add classes to select2 options.
          var option_ids = [];
          $('select#edit-languages-select option').each(function() {
            option_ids.push($(this).attr('id'));
          });
          $(option_ids).each(function(index, value) {
            $('span.languages-select ul.select2-results__options li:nth-child(' + (index + 1) + ')').addClass(value);
          });
        });

        // Set current language in language selector.
        if ($('#edit-languages-select').length = 1) {
          var url_first_part = window.location.pathname.split('/')[1];
          $('#edit-languages-select option').each(function() {
            var option_value = $(this).val();
            var option_text =  $(this).text();
            if (option_value == '/' + url_first_part) {
              $('.languages-select .select2-selection__rendered').attr('title', option_text);
              $('.languages-select .select2-selection__rendered').text(option_text);
            }
            if (option_value == '/') {
              $('.languages-select .select2-selection__rendered').attr('title', 'English');
              $('.languages-select .select2-selection__rendered').text('English');
            }
          });
        }

      }
    }
  };

  Drupal.behaviors.OysterThemeHistory = {
    attach: function (context, settings) {
      var title = $('.oyster-history-block');
      if ((typeof title !== 'undefined') && (title.length > 0)) {
        var x = document.getElementsByClassName('oyster-history-block');
        $(x).each(function () {
          new cbpScroller($(this)[0]);
        });
      }
    }
  };

  Drupal.behaviors.OysterThemeContactSwitcher = {
    attach: function (context, settings) {
      $('.block-webform-block:eq(0)').show();
      $('#block-webformswitcher li:eq(0)').addClass('active');
      $('#block-webformswitcher li').click(function () {
        var form = $(this).data('form');
        $('#block-webformswitcher li').removeClass('active');
        $('.block-webform-block').hide();
        $('.block-webform-block.' + form).show();
        $(this).addClass('active');
      });
    }
  };

  Drupal.behaviors.OysterThemeReadmore = {
    attach: function (context, settings) {
      if ($.isFunction($.fn.readmore)) {
        $('.readmore').readmore({
          speed: 75,
          embedCSS: 'true',
          collapsedHeight: 370,
          moreLink: '<a href="#"><i class="fa fa-plus"></i>Read more</a>',
          lessLink: '<a href="#"><i class="fa fa-minus"></i>Read less</a>'
        });
      }
    }
  };

  Drupal.behaviors.OysterThemeContactMap = {
    attach: function (context, settings) {
      if (jQuery('#contactmap').length > 0) {
        function initialize() {
          var map, loc, iconBase;
          loc = new google.maps.LatLng(51.072559, -1.507899);
          iconBase = '/themes/custom/oystertheme/images/';
          map = new google.maps.Map(document.getElementById('contactmap'), {
            zoom: 11,
            center: loc,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            disableDefaultUI: true
          });

          var marker = new google.maps.Marker({
            position: loc,
            map: map,
            icon: iconBase + 'map-pin.png',
            title: 'PA Hilton'
          });
          map.setZoom(map.getZoom() - 1);
        }

        google.maps.event.addDomListener(window, 'load', initialize);
      }
    }
  };

  Drupal.behaviors.OysterYoutubeFix = {
    attach: function (context, settings) {
      // Fix the width/height issue.
      // See more: https://www.drupal.org/forum/support/post-installation/2020-12-22/adjust-remote-video-embed-dimensions#comment-13946422
      if ($('iframe.media-oembed-content').length) {
        var width = $('iframe.media-oembed-content').width();
        // Adding extra 10px so buttons are visible.
        var height = (width * (9/16)) + 10;
        $('iframe.media-oembed-content').height(height);
      }
    }
  }


  $(window).on('load', function () {
    var hp_news_height = $('#block-views-block-recent-news-block-1 .view-content').outerHeight(true);
    $('.mobile-inactive #block-twitter-block').css('height', hp_news_height);

    $('.mobile-inactive .block-type-50-50-image-text-block').each(function () {
      var height = 0;
      $('.field--name-field-50-50-text').each(function () {
        if ($(this).outerHeight(true) > height) {
          height = $(this).outerHeight(true);
        }
      });

      $('.bg-image').css('height', height);

    });

    $('.mobile-inactive .block-type-grey-image-block').each(function () {
      var height = 0;
      height = $(this).outerHeight(true);
      $('.bg-image').css('height', height);
    });


    $('.eh').matchHeight();
    //remove blank p tags
    $('.oyster_block_quote + p, .oyster_two_col .oyster_right > p').each(function () {
      var $p = $(this),
          txt = $p.html();
      if ((txt.trim() == '') || (txt.trim() == '&nbsp;')) {
        $p.remove();
      }
    });

    if ($.isFunction(jQuery.fn.flexslider)) {
      if ($('.view-case-study-gallery .view-content ul.slides li').length > 1) {
        $('.view-case-study-gallery .view-content > div').flexslider({
          animation: 'slide',
          controlNav: true,
          directionNav: true,
          animationLoop: true,
          slideshow: false,
          itemWidth: 970,
          maxItems: 1,
          fadeFirstSlide: false,
          itemMargin: 0
        });
      }

      if ($('.view-homepage-banner').length > 0) {
        $('.view-homepage-banner .item-list').flexslider({
          animation: 'slide',
          controlNav: false,
          directionNav: true,
          animationLoop: true,
          slideshow: false,
          itemWidth: 970,
          maxItems: 1,
          fadeFirstSlide: false,
          itemMargin: 0,
          selector: 'ul > li'
        });
      }

      if ($('.gallery .field__item').length > 0) {
        $('.gallery').flexslider({
          animation: 'slide',
          controlNav: true,
          directionNav: true,
          animationLoop: true,
          slideshow: false,
          fadeFirstSlide: false,
          prevText: '<i class="fa fa-angle-left"></i>',
          nextText: '<i class="fa fa-angle-right"></i>',
          selector: '.field--name-field-gallery > .field__item'
        });
      }

      if ($('.view-homepage-testimonials').length > 0) {
        $('.mobile-active .view-homepage-testimonials').flexslider({
          animation: "slide",
          animationLoop: false,
          directionNav: false,
          pauseOnHover: false,
          fadeFirstSlide: false,
          slideshow: false,
          controlNav: false,
          minItems: 1,
          maxItems: 1,
          selector: '.view-content > .views-row'
        });
      }

      $('#block-views-block-homepage-products-slider-block-1 .slider-pager').flexslider({
        animation: "slide",
        controlNav: false,
        directionNav: true,
        animationLoop: false,
        slideshow: false,
        itemWidth: 200,
        minItems: getGridSize(),
        maxItems: getGridSize(),
        itemMargin: 0,
        prevText: '<i class="fa fa-angle-left"></i>',
        nextText: '<i class="fa fa-angle-right"></i>',
        asNavFor: '#block-views-block-homepage-products-slider-block-1 .main'
      });

      $('#block-views-block-homepage-products-slider-block-1 .main').flexslider({
        animation: "slide",
        fadeFirstSlide: false,
        itemMargin: 0,
        controlNav: false,
        directionNav: false,
        maxItems: 1,
        slideshow: false,
        sync: '#block-views-block-homepage-products-slider-block-1 .slider-pager'
      });
    }

  });

  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 250) {
      $('.mobile-inactive .page').addClass('shrink');
    }
    else {
      $('.mobile-inactive .page').removeClass('shrink');
    }
  });

  $(document).ready(function () {
    if ($.isFunction($.fn.waypoint)) {
      setTimeout(function () {
        if ($('.desktop-active .header-wrapper').length > 0) {
          var sticky = new Waypoint.Sticky({
            element: $('.desktop-active  .header-wrapper')[0]
          });
        }
      }, 100);
    }
  });

  function getGridSize() {
    return (window.innerWidth < 600) ? 1 : (window.innerWidth < 900) ? 3 : 5;
  }

  var timer;

  $('.products-menu').on('mouseover', function () {
    clearTimeout(timer);
    openSubmenu();
  }).on('mouseleave', function () {
    timer = setTimeout(
        closeSubmenu
        , 500);
  });

  $("#block-mainnavigation-2").mouseleave(function () {
    $(this).removeClass('open');
  });

  function openSubmenu() {
    $("#block-mainnavigation-2").addClass('open');
    $('.products-menu').addClass('active');
  }

  function closeSubmenu() {
    if (!$('#block-mainnavigation-2').is(':hover')) {
      $("#block-mainnavigation-2").removeClass('open');
      $('.products-menu').removeClass('active');
    }
  }

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

})(jQuery, window, Drupal);
